import { cn } from '@/lib/utils'

export type HistoryRowKind = 'keep' | 'add' | 'remove' | 'change'

const LABELS: Record<HistoryRowKind, string> = {
  keep: 'Finns',
  add: 'Läggs till',
  remove: 'Tas bort',
  change: 'Ändras'
}

const STYLES: Record<HistoryRowKind, string> = {
  keep: 'bg-muted text-muted-foreground border-border',
  add: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  remove: 'bg-rose-50 text-rose-700 border-rose-200',
  change: 'bg-amber-50 text-amber-700 border-amber-200'
}

export function HistoryRowTag({ kind }: { kind: HistoryRowKind }): React.ReactElement {
  return (
    <span
      className={cn('inline-flex w-20 justify-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium', STYLES[kind])}
    >
      {LABELS[kind]}
    </span>
  )
}
